import './style.css'

function Loader() {
  return <div className='preloader'></div>
}

export default Loader
